import httpStatus from 'http-status';
import React, { Component } from 'react';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';

import { rolesService } from '../../_services/roles.service';

class RolesOptions extends Component
{
  state = {
    defaultValue: null,
    selected: null,
    options: []
  }

  componentDidMount() {
    rolesService.retrieveOptionsRoles()
      .then(response => {
        if (response && response.status === httpStatus.OK) {
          this.setState({
            options: response.data.data.map(result => {
              return { value: result.id, label: result.name }
            }).filter(row => {              
              if (!this.props.excludeById) {
                return row
              }

              return row.value !== this.props.excludeById
            })
          }, this.selectDefaultAndBubble)
        }
      })
  }

  selectDefaultAndBubble() {
    if (this.props.defaultValue) {
      const option = this.state.options.find(option => {
        return option.label === this.props.defaultValue[0]
      });
  
      this.setState({ selected: option })
  
      this.props.handleSelected(option)
    }
  }

  render () {
    const { options, selected } = this.state;

    if (options.length === 0) {
      return <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    }

    return <Select
      value={selected || ''}
      placeholder='Select a role'
      isClearable={true}
      options={options}
      onChange={option => {
        this.setState({
          selected: option ?? null
        })

        this.props.handleSelected(option ?? null)
      }}
      isDisabled={this.props.disabled}
      styles={{
        container: (styles) => {
          return {
            ...styles,
            zIndex: 10,
          }
        },
        placeholder: (styles) => {
          return {
            ...styles, 
            color: 'RGB(201, 201, 201)',
            fontWeight: 300,
          };
        },
        control: (styles) => {
          return {
            ...styles, 
            border: this.props.invalid ? '1px solid red' : '',
          };
        },
      }}
    />
  }
}

export default RolesOptions